import { useEffect } from "react";

import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";

export function useDatadogRum() {
  useEffect(() => {
    if (
      !import.meta.env.VITE_DD_APPLICATION_ID ||
      !import.meta.env.VITE_DD_CLIENT_TOKEN
    ) {
      if (import.meta.env.VITE_ENV !== "production") {
        console.warn("Datadog RUM is not configured. Skipping initialization.");
      }
      return;
    }

    if (!datadogRum.getInitConfiguration()) {
      datadogRum.init({
        applicationId: import.meta.env.VITE_DD_APPLICATION_ID,
        clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN,
        version: import.meta.env.VITE_DD_VERSION,
        site: import.meta.env.VITE_DD_SITE || "us5.datadoghq.com",
        service: "solace-patient-xp-logon",
        env: import.meta.env.VITE_ENV,
        sessionSampleRate: 100,
        trackSessionAcrossSubdomains: true,
        sessionReplaySampleRate: 20,
        defaultPrivacyLevel: "mask-user-input",
        trackUserInteractions: true,
        plugins: [reactPlugin()],
      });
    }
  }, []);
}
